<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>
<section>
  <div class="container m-t-alt">
    <div class="columns" *ngIf="faqContent">
      <div class="column is-11-tablet is-8-desktop m-b-0">
        <div [innerHTML]="faqContentSafeHtml"></div>
      </div>
    </div>
  </div>

  <div class="container m-t-rel" *ngIf="faqs">
    <div class="columns">
      <div class="column is-8 is-offset-2">
        <div class="card p-a-xxl m-b-xxl">
          <div class="flex justify-center align-center dir-col-touch">
            <p i18n="@@faqQuestion" class="m-y-xl m-x-xl">
              If you have another question, please contact us
            </p>
            <a i18n="@@faqButton" routerLink="/contact" class="m-x-xl button">
              Contact
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-tools-catalogue-disclaimer></app-tools-catalogue-disclaimer>
